export const FETCH_POSTS_REQUEST='FETCH_POSTS_REQUEST'
export const FETCH_POSTS_SUCCESS='FETCH_POSTS_SUCCESS'
export const FETCH_POSTS_FAILURE='FETCH_POSTS_FAILURE'